import script from "./MTournamentRegistration.vue?vue&type=script&setup=true&lang=ts"
export * from "./MTournamentRegistration.vue?vue&type=script&setup=true&lang=ts"

import "./MTournamentRegistration.vue?vue&type=style&index=0&id=0fd5de38&lang=less"

const __exports__ = script;

export default __exports__